import { Link as RouterLink } from "react-router-dom";
import {
    AppBar,
    Box,
    Hidden,
    IconButton,
    Toolbar,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Logo from "src/components/Logo";
import FirstMileNotifications from "./FirstMileNotifications";
import { CreditsAndPlansDetails, ElevationScroll } from "../components";
import ProfileAvatar from "../components/ProfileAvatar";
import { AppBarLocalizationMenu } from "src/services/public/layout/components/navigation-bar/components/localization";

export default function FirstMileAppBar({ toggleDrawer, merchant, ...rest }) {

    return (
        <ElevationScroll>
            <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <Toolbar>
                    <Hidden lgUp>
                        <IconButton color="inherit" onClick={toggleDrawer} size="large">
                            <MenuIcon />
                        </IconButton>
                    </Hidden>
                    <RouterLink to="/">
                        <Logo
                            type="light"
                            style={{
                                marginInlineStart: "4vw" /*128 - 16 - 36 - 10*/,
                            }}
                        />
                    </RouterLink>
                    <Box sx={{ flexGrow: 1 }} />
                    <CreditsAndPlansDetails />
                    <FirstMileNotifications />
                    <ProfileAvatar />
                    <AppBarLocalizationMenu reload={true} sx={{ display: { xs: 'none', md: 'inline-block' } }} />
                </Toolbar>
            </AppBar>
        </ElevationScroll>
    )
}